import { render, staticRenderFns } from "./omsetarea_chart.vue?vue&type=template&id=7157e301"
import script from "./omsetarea_chart.vue?vue&type=script&lang=js"
export * from "./omsetarea_chart.vue?vue&type=script&lang=js"
import style0 from "./omsetarea_chart.vue?vue&type=style&index=0&id=7157e301&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports